"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

exports.__esModule = true;

var logos_1 = __importDefault(require("./logos"));

var tokens_json_1 = __importDefault(require("./tokens.json"));

var testnetTokens = [{
  address: '0x184F7b12f29d675f34ff816528ADBfd0E0501Ad4',
  ethereum: '0x7a7EbBDa6AE5c7EB5738FC8eFf675C0D71AA05A1',
  logo: logos_1["default"].WNRGLogo
}, {
  address: '0x3e798553502042088783B83e4B62e22152E8717e',
  ethereum: '0x2726Dd5efb3A209a54C512e9562A2045B8F45DBc',
  logo: logos_1["default"].DAILogo
}, {
  address: '0x01a5534f82Ab54e1F37Ee585F3049Cf8B80f79A4',
  ethereum: '0x28cBB891400BD3cCF52c50F30FD24Ee503718054',
  logo: logos_1["default"].ETHLogo
}, {
  address: '0x6EAdB8BA9b1054fC7D82B4129EbBEFF807852190',
  ethereum: '0xa255461fF545d6ecE153283f421D67D2DE5D0E29',
  logo: logos_1["default"].BTCLogo
}, {
  address: '0xDFf7a6F2CDdD46c1a36Ae760fEbc399208e86E0A',
  ethereum: '',
  logo: logos_1["default"].UNILogo
}, {
  address: '0x7A7EC4F35953BCDd61f49FADa94510C842eB0cc3',
  ethereum: '',
  logo: logos_1["default"].AAVELogo
}, {
  address: '0x0b49Cc042815b0E233D75e38766C95576Be11766',
  ethereum: '',
  logo: logos_1["default"].LINKLogo
}, {
  address: '0xD1E1f860D239A519c5b166b1334b71c78451D7B9',
  ethereum: '',
  logo: logos_1["default"].SNXLogo
}, {
  address: '0x4EBF160f8df0839911d5d44849E55bBE16ef1BCF',
  ethereum: '',
  logo: logos_1["default"].YFILogo
}, {
  address: '0xBe941a19692d34D263402EE83830Ad7F21648453',
  ethereum: '',
  logo: logos_1["default"].ONEINCHLogo
}, {
  address: '0xDdE8C0A5689Df5cBa8eE1C1AbF0c0f582d91327C',
  ethereum: '',
  logo: logos_1["default"].DOTLogo
}, {
  address: '0x0c3D76CD91eaF22ac733fd46Cc263179527E900e',
  ethereum: '',
  logo: logos_1["default"].BNBLogo
}, {
  address: '0x853632f2578fA94Bf16e63bC66f1C44f4976aA70',
  ethereum: '',
  logo: logos_1["default"].AVAXLogo
}, {
  address: '0xbCbD61E3079F915FB22cFC335823d1A4C3188E22',
  ethereum: '',
  logo: logos_1["default"].CRVLogo
}, {
  address: '0x17D9061E6d76De5eC07dd68398b82802A5df1d8e',
  ethereum: '',
  logo: logos_1["default"].LTCLogo
}, {
  address: '0x986669C72EA2E547c537fB87116b26e00B39a277',
  ethereum: '',
  logo: logos_1["default"].BCHLogo
}, {
  address: '0xa596fa183c87489D29A980E203EFBac32053b6C9',
  ethereum: '',
  logo: logos_1["default"].DOGELogo
}, {
  address: '0x2394264A934E3c735Cbf47Dd505d7C0090c0756b',
  ethereum: '',
  logo: logos_1["default"].CAKELogo
}, {
  address: '0xcf7F37994acb8C7976dE56eB335a47944f8AC13b',
  ethereum: '',
  logo: logos_1["default"].ADALogo
}, {
  address: '0xF4c9b74088d9A4ac39C3726992f53bDed20A57Eb',
  ethereum: '',
  logo: logos_1["default"].XRPLogo
}, {
  address: '0xC050b84535e840D4150b57e0CabBdAef3EBDee95',
  ethereum: '',
  logo: logos_1["default"].XLMLogo
}, {
  address: '0xAFA6831AcB26a039b81834854Fa593f837e2457E',
  ethereum: '',
  logo: logos_1["default"].DASHLogo
}, {
  address: '0x47AB7146b551dc8D767323Adbab540b8Dfcd0160',
  ethereum: '',
  logo: logos_1["default"].XMRLogo
}, {
  address: '0xe4058c6E482a510F0e000F3A3ddbe93095bF314f',
  ethereum: '',
  logo: logos_1["default"].ATOMLogo
}, {
  address: '0x6D13B34cB3c062687d6eFf4e2E1E7581B6f37dae',
  ethereum: '',
  logo: logos_1["default"].SUSHILogo
}, {
  address: '0xe13141DB67FE63B81ca680479C6B75fe02F9A08c',
  ethereum: '',
  logo: logos_1["default"].BADGERLogo
}, {
  address: '0x16208c491bfd4bA9324379C67Ce30b0d1b916311',
  ethereum: '',
  logo: logos_1["default"].LRCLogo
}, {
  address: '0x16B652ad30b11A20D31Efe1A93f54a0776C250Aa',
  ethereum: '',
  logo: logos_1["default"].BALLogo
}, {
  address: '0x164dabBC8F2A3Cc18b8Bcf8CA7862D7b560ED2F0',
  ethereum: '',
  logo: logos_1["default"].RUNELogo
}, {
  address: '0xACDb2d49f7b4b77133Aa98Fd0098262DB6892035',
  ethereum: '',
  logo: logos_1["default"].GRTLogo
}, {
  address: '0xE0588cD0d0b2104aC72f6bE3B65BeF65d7c50F7A',
  ethereum: '',
  logo: logos_1["default"].FILLogo
}, {
  address: '0x2d3Fe30930f2D91aad22ABcA2c6B9DB547676334',
  ethereum: '',
  logo: logos_1["default"].XEMLogo
}, {
  address: '0xaE12f6B364Cba50A6224B86ee55C27594953747e',
  ethereum: '',
  logo: logos_1["default"].HEGICLogo
}, {
  address: '0xeb4d857b7E13DA94f87DFFf21865dA3d93c4F1Ad',
  ethereum: '',
  logo: logos_1["default"].SOLLogo
}, {
  address: '0x34Ef9282f3d461Ada1c86C0eaa6DbB0464de04e6',
  ethereum: '',
  logo: logos_1["default"].BNTLogo
}, {
  address: '0x094510Cb85c15E36Af130a661e03d7138e9C5d66',
  ethereum: '',
  logo: logos_1["default"].DODOLogo
}, {
  address: '0x257c2Cfa0E0fAfD07E999cbd80783e6c00296BC3',
  ethereum: '',
  logo: logos_1["default"].MKRLogo
}, {
  address: '0x0EC25E6b2CA8227799415C12B1e5118Fa8a76b5D',
  ethereum: '',
  logo: logos_1["default"].NEOLogo
}, {
  address: '0xA25859a45fFe6F9e99583FA376A302958CA13713',
  ethereum: '',
  logo: logos_1["default"].EOSLogo
}, {
  address: '0x2f512f7Fa8A6D6C51A5670CE7Af83Af8b41DA725',
  ethereum: '',
  logo: logos_1["default"].MIOTALogo
}, {
  address: '0xfcE07C45a11ddd40fBe6464166C752A8E2eca760',
  ethereum: '',
  logo: logos_1["default"].XTZLogo
}, {
  address: '0xf320c1Aa1e6b37582D480de10fF44C3e9De19544',
  ethereum: '',
  logo: logos_1["default"].THETALogo
}, {
  address: '0x8f0cf8136b0042CA59563759f66556EaeFEbBb38',
  ethereum: '',
  logo: logos_1["default"].COMPLogo
}, {
  address: '0x25aA46eD3975DAe99fD990590ed4fAe623329545',
  ethereum: '',
  logo: logos_1["default"].TRXLogo
}, {
  address: '0xF3a209a4b94F315F2DD305253B5801ede1Ba249F',
  ethereum: '',
  logo: logos_1["default"].OKBLogo
}, {
  address: '0x582A1b770465F838bEc408b19aAd609E7645d70a',
  ethereum: '0xEb7a80A1a32142f64874a48012bd6165990a37D5',
  logo: logos_1["default"].CROLogo
}, {
  address: '0x7e948d73A419cEbfCa78d001aB0B832020443F82',
  ethereum: '',
  logo: logos_1["default"].VETLogo
}, {
  address: '0x2998F31252B004524f1AB9d080Abb2e4563894f6',
  ethereum: '',
  logo: logos_1["default"].LUNALogo
}, {
  address: '0x628Fd4Dec217E71f23abED8829de6795de95C52c',
  ethereum: '',
  logo: logos_1["default"].BSVLogo
}, {
  address: '0x366FCFe4d06fC71a76B052bB663ebE9Dd48b20C5',
  ethereum: '',
  logo: logos_1["default"].HTLogo
}, {
  address: '0xE2D53E1EDA5A2eE3cfc230C3c0b1303c61B05e80',
  ethereum: '',
  logo: logos_1["default"].FTTLogo
}, {
  address: '0xfAC9D45b9F7A0050df8AC1E23742CB040b2798a3',
  ethereum: '',
  logo: logos_1["default"].EGLDLogo
}, {
  address: '0x9E219B116f8Ab9939B466885034438b4120601Ed',
  ethereum: '',
  logo: logos_1["default"].KSMLogo
}, {
  address: '0x6e5084BC578E98F9206794158a58ED51D2F0D630',
  ethereum: '',
  logo: logos_1["default"].DCRLogo
}, {
  address: '0x4FF4937E25d09D903D6d915F01BCbBeF9C6b66AE',
  ethereum: '',
  logo: logos_1["default"].LEOLogo
}, {
  address: '0x573CAF5D46BC0273985C68e2512DE063C6B68E8F',
  ethereum: '0x9D8F944FEfFFE440BF9C62F04ACCA274bA8ab513',
  logo: logos_1["default"].CELLogo
}, {
  address: '0xCDEabF84ECa4B1bcb596b3DB78f478bfae986D27',
  ethereum: '0x51Be1a3729CbE7D5Ef3eAF0B1F1000F4e19bf22F',
  logo: logos_1["default"].ZILLogo
}, {
  address: '0xA7EAef5D1d99Eaf16bd8188fEAa6fA58Efc9e9BA',
  ethereum: '',
  logo: logos_1["default"].STXLogo
}, {
  address: '0xf90a96C5D2BE241EdEa659bC76c6b386D559bEfD',
  ethereum: '',
  logo: logos_1["default"].ZECLogo
}, {
  address: '0x7f2626377a4f77b1Ac8241096E4E540214dE894a',
  ethereum: '0x3877dF0Abbaa774484c2096fCc968E201Ed982C3',
  logo: logos_1["default"].VGXLogo
}, {
  address: '0xAFF55118A0C7e2502B0bFed5883636EAdeC22032',
  ethereum: '',
  logo: logos_1["default"].NEARLogo
}, {
  address: '0x52f500Ac02B161F735D31d37ce10B44f9053756F',
  ethereum: '',
  logo: logos_1["default"].RVNLogo
}, {
  address: '0x0dCf1d1123e7c0dAB00dD7217d4ee3eeE76190d0',
  ethereum: '',
  logo: logos_1["default"].ETCLogo
}, {
  address: '0x99ac22bC633E5F2aEF905Ed23235448Fd3aBf052',
  ethereum: '',
  logo: logos_1["default"].FTMLogo
}, {
  address: '0x0a8C3d19b856Fc032A06A6C9DD9d0c580Ce7a536',
  ethereum: '',
  logo: logos_1["default"].NEXOLogo
}, {
  address: '0xDbE70583818B4c5D3d504533200b304eBAdc9139',
  ethereum: '',
  logo: logos_1["default"].ENJLogo
}, {
  address: '0x6759027e1cf75DD4DD1a424C7e4a4892B1fEd7EA',
  ethereum: '',
  logo: logos_1["default"].UMALogo
}, {
  address: '0x21c23364306BAC0Abfe978BE9B9d955993D9e3ac',
  ethereum: '',
  logo: logos_1["default"].HBARLogo
}, {
  address: '0xA2962DCC41b4a6bF6eE121f5581C43b1C4cF37F5',
  ethereum: '0xDEB56757aa46b1Ca3c5a40376B1d7DD395381f58',
  logo: logos_1["default"].CHSBLogo
}, {
  address: '0x11c5ca296a3773D84698F559df9dF6cC31720bBa',
  ethereum: '',
  logo: logos_1["default"].ICXLogo
}, {
  address: '0xb3E99ab3133346430905cA9BEfBB09cB72A71b3a',
  ethereum: '',
  logo: logos_1["default"].MATICLogo
}, {
  address: '0x9cEF810d3db207aF90D12f5Fa38324c285B447Fb',
  ethereum: '',
  logo: logos_1["default"].ZRXLogo
}, {
  address: '0xd197D59d95A97227511187264A44F9a5739b30d4',
  ethereum: '',
  logo: logos_1["default"].BATLogo
}, {
  address: '0xe7DC6a7900e4a143577C5aE67A8BbfEaE20a464B',
  ethereum: '',
  logo: logos_1["default"].WAVESLogo
}, {
  address: '0xE34C818a94Cec117Ce949fC90927101DC8dbc8E2',
  ethereum: '',
  logo: logos_1["default"].RENLogo
}, {
  address: '0x27cE95bF524030Be09B13459B2F2b4ef678cB196',
  ethereum: '',
  logo: logos_1["default"].IOSTLogo
}, {
  address: '0x869D7A42DC851088A8883260E8730C87304eD69e',
  ethereum: '',
  logo: logos_1["default"].ALGOLogo
}, {
  address: '0x33526Bb5413b83f353Bb8A92d9eB121ade73082B',
  ethereum: '',
  logo: logos_1["default"].BTTLogo
}, {
  address: '0x2a0ED5ED72ca0659F3a3F94B2FD128D0422Ea34e',
  ethereum: '',
  logo: logos_1["default"].ONTLogo
}, {
  address: '0x905d33aFf7c453d9E1e07443e6A10C353F728Eeb',
  ethereum: '',
  logo: logos_1["default"].AMPLogo
}, {
  address: '0x3c5a8b58C22c0565c4f7dA7655277bC0277502d9',
  ethereum: '',
  logo: logos_1["default"].DGBLogo
}, {
  address: '0xf2D4a05eB7E5A07b08199924B483185e231e0b9b',
  ethereum: '',
  logo: logos_1["default"].NANOLogo
}, {
  address: '0xC45d750dadDa39Ea11Bd3c789ad00397A3b32a4f',
  ethereum: '',
  logo: logos_1["default"].ZKSLogo
}, {
  address: '0xf041B26BBB04019C778eAe9364766fFfec43C3eF',
  ethereum: '',
  logo: logos_1["default"].OMGLogo
}, {
  address: '0x6Abf20af734b6608b4c377e25e4d93493dE0D71d',
  ethereum: '',
  logo: logos_1["default"].QTUMLogo
}, {
  address: '0x03Ab3b9B26310De5f0f6EE8Be99B165D4dcBd9d2',
  ethereum: '',
  logo: logos_1["default"].ARLogo
}, {
  address: '0xFA714E3519c6D4551dA6Edc670581284f1e0A449',
  ethereum: '',
  logo: logos_1["default"].MDXLogo
}, {
  address: '0x78226568EFb9b05D714960e54Ae9feF2C4a504Dd',
  ethereum: '',
  logo: logos_1["default"].CHZLogo
}, {
  address: '0x70bE65E35D4944e229205CDF1CCbb79157347ea3',
  ethereum: '',
  logo: logos_1["default"].HOTLogo
}, {
  address: '0x307270c4117807163bea18C30536d0fAD979D794',
  ethereum: '',
  logo: logos_1["default"].RSRLogo
}, {
  address: '0xCBAfeEC9dF8449D17aDcF37E8a1cbd3A0fD609E2',
  ethereum: '',
  logo: logos_1["default"].EWTLogo
}, {
  address: '0xb6865b97F72275B16Ca2D1878e5293119aC9c323',
  ethereum: '',
  logo: logos_1["default"].SCLogo
}, {
  address: '0xD87CA973186B2aEd290cE02940441207B3191502',
  ethereum: '',
  logo: logos_1["default"].MANALogo
}, {
  address: '0x49fE2a93F4253890a136afe679bd909eA5a99A14',
  ethereum: '',
  logo: logos_1["default"].OCEANLogo
}, {
  address: '0xD19A46C173e725627481000704874D1AB6C8D054',
  ethereum: '',
  logo: logos_1["default"].ALPHALogo
}, {
  address: '0x4656d7933F718F672C5B1752C0c19de4458be324',
  ethereum: '',
  logo: logos_1["default"].NPXSLogo
}, {
  address: '0x8C7f957930014c04FF49304ca5B7a17B1567a3d5',
  ethereum: '',
  logo: logos_1["default"].KNCLogo
}, {
  address: '0x35CA06f0f20672DCb234B07340D9d06475458e66',
  ethereum: '',
  logo: logos_1["default"].REEFLogo
}, {
  address: '0xb83Dc75Ea3128b422E12F86432f8b97E7d6eCC97',
  ethereum: '',
  logo: logos_1["default"].LSKLogo
}, {
  address: '0x0511e40764c55f2e2e39C00e0C3A9B052a65AeF9',
  ethereum: '',
  logo: logos_1["default"].QNTLogo
}, {
  address: '0x758f7662982322d7b1d3eac685Ad5f120a229Be0',
  ethereum: '',
  logo: logos_1["default"].NXMLogo
}, {
  address: '0x6a3C924c82cb56DEF2Ab52673dBfa6bD51755cea',
  ethereum: '',
  logo: logos_1["default"].ZENLogo
}, {
  address: '0x730aF54b6305D73e404a88367283d812F1d4Ee08',
  ethereum: '',
  logo: logos_1["default"].CELOLogo
}, {
  address: '0x5753479DaB578a30483D755951c70cf11d5c8c31',
  ethereum: '',
  logo: logos_1["default"].SNTLogo
}, {
  address: '0xDeEb0125eBC2Ef2BD4D2cC31f9761C7F75Df29Da',
  ethereum: '',
  logo: logos_1["default"].ONELogo
}, {
  address: '0x89186638c77F9FcaFC4F749E30dabFD72E3e6d70',
  ethereum: '',
  logo: logos_1["default"].HNTLogo
}, {
  address: '0x1b22CcA20D9D727F372736a4905FDd053Af1Fb52',
  ethereum: '',
  logo: logos_1["default"].CKBLogo
}, {
  address: '0xF6008c808A344BfBf2A9595fac5B606e6D0147c3',
  ethereum: '',
  logo: logos_1["default"].KAVALogo
}, {
  address: '0x318d8ba669499Bda2796Af134B9aBCC8f067E9d1',
  ethereum: '',
  logo: logos_1["default"].ARDRLogo
}, {
  address: '0x0E92Da0d4a1C7a8632Af436Ed8d2B768598AdecB',
  ethereum: '',
  logo: logos_1["default"].ARKLogo
}, {
  address: '0xf32ad72B317CaEBE7Cf977C4c8e0466DCEeF4595',
  ethereum: '0xb9f6B603E7333545480c5e97A11049Caa254b12c',
  logo: logos_1["default"].SCRTLogo
}, {
  address: '0xc35a618657539032e3053473d70777c29D0B86C2',
  ethereum: '',
  logo: logos_1["default"].SFPLogo
}, {
  address: '0xFFB56E34BEb20f1d9Ee172783189e84C116F47ED',
  ethereum: '',
  logo: logos_1["default"].RIFLogo
}, {
  address: '0xB96f02aA397c033de51B33108c6593c736235c2A',
  ethereum: '',
  logo: logos_1["default"].ROSELogo
}, {
  address: '0x024EF0BAE3daDEdFE2a53b41B281AE3eeFD8182b',
  ethereum: '',
  logo: logos_1["default"].TWTLogo
}, {
  address: '0x958f0A1c079B5d5eAAaFf7F8A1b3ADEbB322C0F6',
  ethereum: '',
  logo: logos_1["default"].KMDLogo
}, {
  address: '0xC71d34f2aeB6Be37009dAf593AEe2D54dBA5D20A',
  ethereum: '',
  logo: logos_1["default"].STEEMLogo
}, {
  address: '0x0324FCD1230c85b4B04F4f52a343f99dfF1d765d',
  ethereum: '',
  logo: logos_1["default"].TOMOLogo
}, {
  address: '0xe3F7d9b688D58903a2F2393408932B4e91bB9d94',
  ethereum: '',
  logo: logos_1["default"].GLMLogo
}, {
  address: '0xB445423563c24CF04DD1c7b176Af3326d3De9EF2',
  ethereum: '0x9fA1b5b94B1cFD9EACA768ed12F681e43630CB3c',
  logo: logos_1["default"].ORNLogo
}, {
  address: '0x943378aCE4a9F6a85BbacE950A288E8A1E4b51Fb',
  ethereum: '0xACe3b88d92DC0c8e1AFFE6e7Cc468bB596a48D98',
  logo: logos_1["default"].AMPLLogo
}, {
  address: '0x9AaB9f8d302E84E66C3C2198d42B8e538FD6be2D',
  ethereum: '',
  logo: logos_1["default"].POLYLogo
}, {
  address: '0xFE817dADB631B95593A5d772a342E3e58FCa3ba9',
  ethereum: '',
  logo: logos_1["default"].BANDLogo
}, {
  address: '0xdd5F80026a78e050d20Ea4fF6609E7d5603B42c2',
  ethereum: '',
  logo: logos_1["default"].SWAPLogo
}, {
  address: '0xb8822BcFbBd09856C3D5e9D3b54426cE2f470eB5',
  ethereum: '',
  logo: logos_1["default"].POLSLogo
}, {
  address: '0x45940e31ca5B8d3e9F59c6216c71616A0e8527A2',
  ethereum: '',
  logo: logos_1["default"].SANDLogo
}, {
  address: '0x6C4Fa72C91F3779876027fDA9601daCddC701FD5',
  ethereum: '',
  logo: logos_1["default"].NULogo
}, {
  address: '0x8EF411A7c2bB27f87e8E671E3bc7AE53F80094E7',
  ethereum: '',
  logo: logos_1["default"].MIRLogo
}, {
  address: '0xaA60bA281BB3d2f07345AEF85F9c5eea3625e9cB',
  ethereum: '',
  logo: logos_1["default"].SFILogo
}, {
  address: '0xf1F9a98BcACa540f003D234478F9d18eF60A2202',
  ethereum: '',
  logo: logos_1["default"].GNOLogo
}, {
  address: '0xE5cf5F20B09bdEE29a124B4d19B58Fd6b6E9A2E9',
  ethereum: '',
  logo: logos_1["default"].COTILogo
}, {
  address: '0x5d7867cAf5D0e62170eF58092bf466cf0a3E92CB',
  ethereum: '',
  logo: logos_1["default"].RFOXLogo
}, {
  address: '0x1D5D8F5C820f05128709EC1a423Fb6700326c45F',
  ethereum: '0xDf720271030A406E7F93CCc183bC99AE548af4F8',
  logo: logos_1["default"].FUNLogo
}, {
  address: '0x65658F6A3D1370B476c46f121Cc925a3fF470FC6',
  ethereum: '',
  logo: logos_1["default"].ANTLogo
}, {
  address: '0xc91B0d119660A7Ead86D9d87fcB6EC03f925B6D7',
  ethereum: '',
  logo: logos_1["default"].REPLogo
}, {
  address: '0x73f62914Bd1516159602A7161E49beE6a437bc8c',
  ethereum: '',
  logo: logos_1["default"].MASKLogo
}, {
  address: '0xaFB454D68232df125269C296267F1f1F9a8EB964',
  ethereum: '',
  logo: logos_1["default"].INJLogo
}, {
  address: '0xF078abE9Af3202952172d78830509757c099EDa3',
  ethereum: '0x1d4D022C74c7Ace64f31eB49C147442C021A9fB3',
  logo: logos_1["default"].UBTLogo
}, {
  address: '0x3766Ad5E3294f857bb99588f6227C229123cFa7C',
  ethereum: '0xf798c471573478eaCBfb4D0dB4C23959428426a8',
  logo: logos_1["default"].CVCLogo
}, {
  address: '0x03fA58cfce1A46CE326505c4304ABbD7b0a65a5D',
  ethereum: '0x1f7f4AB11113A1aF54c3dFa9dDe636DBe67251B6',
  logo: logos_1["default"].SRMLogo
}, {
  address: '0xB2799025d32AcFC2D4A5E2c75446117f3978043c',
  ethereum: '',
  logo: logos_1["default"].ANKRLogo
}, {
  address: '0x65598d0974dE197d3AB0587B00bB39122a889767',
  ethereum: '',
  logo: logos_1["default"].NMRLogo
}, {
  address: '0xA350342017B738Cc2332D89F098785d3c1c03465',
  ethereum: '',
  logo: logos_1["default"].DNTLogo
}, {
  address: '0xebfe4F0f1bF4191a594266aEbAECA70BaD931db7',
  ethereum: '',
  logo: logos_1["default"].IOTXLogo
}, {
  address: '0x694E1F34Fd8797868F28cC477b093B5E154df1bc',
  ethereum: '',
  logo: logos_1["default"].BTSLogo
}, {
  address: '0x48272273C8dD4753935FA5d6B746c1C532f021a2',
  ethereum: '',
  logo: logos_1["default"].SYSLogo
}, {
  address: '0xe33c6D78739B082760f7aC1353f2d8988bEB8BdA',
  ethereum: '',
  logo: logos_1["default"].OGNLogo
}, {
  address: '0x66d337216ad4f8625f935EE094693f8a9964cb9B',
  ethereum: '',
  logo: logos_1["default"].AVALogo
}, {
  address: '0x2C2933fd7c6eE664d77eA825eeb99Fe1C9584341',
  ethereum: '',
  logo: logos_1["default"].NXSLogo
}, {
  address: '0xA0A37314971c992F970dd8B2B1ee9494349C0B1e',
  ethereum: '0x18ee43B5dE75198954cd2C1Ec4a4242206ff93C2',
  logo: logos_1["default"].AIONLogo
}, {
  address: '0xC672799ef8a60eF87211F3122A679c38C867b798',
  ethereum: '',
  logo: logos_1["default"].HARDLogo
}, {
  address: '0x57596921837e7c75fAf1E45C3705064c58c73BF3',
  ethereum: '',
  logo: logos_1["default"].TRBLogo
}, {
  address: '0x7dA04C58A335E8ADc065E9C49Efb17C5ec4Fb04A',
  ethereum: '',
  logo: logos_1["default"].CTKLogo
}, {
  address: '0x693F2A4B173bF3A8fa19A19C9F26AFAd12cB9349',
  ethereum: '',
  logo: logos_1["default"].WANLogo
}, {
  address: '0xDc7FE2C0C50Ca268F754062dD2ae31d06Ea28B9b',
  ethereum: '',
  logo: logos_1["default"].CELRLogo
}, {
  address: '0xaA9Cd4A847b499D3f2f370bb75e7cAF37CaD5602',
  ethereum: '',
  logo: logos_1["default"].LOOMLogo
}, {
  address: '0x9d894c50E3D89902D308DB8B7CAe369c4A353240',
  ethereum: '',
  logo: logos_1["default"].HIVELogo
}, {
  address: '0x70B75c0ef271acf6C1aFA444E752feE92a429EDf',
  ethereum: '',
  logo: logos_1["default"].QKCLogo
}, {
  address: '0xcF39799350179Ca0FB9b8664da7bde6B543F958a',
  ethereum: '',
  logo: logos_1["default"].AKROLogo
}, {
  address: '0x978613EEe42f1808ED6dF68E0Fa13A6649a075c9',
  ethereum: '0x047186C60B2C830f7db02bf032A78937682193e7',
  logo: logos_1["default"].PPTLogo
}, {
  address: '0x81A39E1Ad6F8F1fD67E2a726e986953122B1CafB',
  ethereum: '0x43b7cC429791a9BE3590f9297c8B43ac66AEEc6b',
  logo: logos_1["default"].STORJLogo
}, {
  address: '0xb81e3a767C82dE1c7113845DfEa2FF84C56D54Ab',
  ethereum: '',
  logo: logos_1["default"].AUDIOLogo
}, {
  address: '0x9433420c647Cc39d3Ce0F48e909aCe5458Aa494C',
  ethereum: '',
  logo: logos_1["default"].DUSKLogo
}, {
  address: '0x35B4633a6Bb5B3dB699CeF02F56FfCad41333D8F',
  ethereum: '',
  logo: logos_1["default"].YFIILogo
}, {
  address: '0x41a32e8C1Db7b3C81A022f9cA28D08e2305adbd4',
  ethereum: '',
  logo: logos_1["default"].CREAMLogo
}, {
  address: '0xd4F16Fbc222C3Da193E5f3e67aae63A008EFcF92',
  ethereum: '0x7075CE4Bb5223460A565A801f45438393404A225',
  logo: logos_1["default"].MTLLogo
}, {
  address: '0x57d00a529464893c189cE4873C815BD183Bbe7E4',
  ethereum: '',
  logo: logos_1["default"].GHSTLogo
}, {
  address: '0xaAFDE457Bf459f6C9b85473530BDA1000904B1D6',
  ethereum: '',
  logo: logos_1["default"].WRXLogo
}, {
  address: '0xf655da894Bf373494af2de626164a8620972DC8a',
  ethereum: '',
  logo: logos_1["default"].BLZLogo
}, {
  address: '0x7015A9287222c87271a63b99aC2651C5c0d8Ff90',
  ethereum: '',
  logo: logos_1["default"].MFTLogo
}, {
  address: '0x2D124F2BdEc78a7d0f8405bb501b067aBeb76Bd8',
  ethereum: '',
  logo: logos_1["default"].ROOKLogo
}, {
  address: '0x712C029cd1f520655f4073F0D8c1E2e979C8D5fa',
  ethereum: '',
  logo: logos_1["default"].RGTLogo
}, {
  address: '0x01Ee03b1F43Dc754Cb4e7112f8741230b5FbA9a3',
  ethereum: '',
  logo: logos_1["default"].KEEPLogo
}, {
  address: '0x4b9e624C7ae53da783d83AC0FAF56775e778F6A2',
  ethereum: '0x963D66c53F7861c8D7Bed6772d1F0e0f9ce1B3d0',
  logo: logos_1["default"].POWRLogo
}, {
  address: '0xc8C28d629DF35556F1899A07B08a058944Dc122D',
  ethereum: '',
  logo: logos_1["default"].PERPLogo
}, {
  address: '0xEE135bf931364BfA3CFc712EFBae9572a3c561BE',
  ethereum: '',
  logo: logos_1["default"].PAXGLogo
}, {
  address: '0x831E043DeEF137ECE431e745D95117A661360645',
  ethereum: '',
  logo: logos_1["default"].DPILogo
}, {
  address: '0xca350CADf053f74512e38Bf60B563F2D8df7F812',
  ethereum: '',
  logo: logos_1["default"].SUPERLogo
}, {
  address: '0x06ce3F78FC7794A0BDc357838D5D1679c1879351',
  ethereum: '',
  logo: logos_1["default"].FARMLogo
}, {
  address: '0x1DaCA316cbd6992A029147f8fc92A0Dd715E62B2',
  ethereum: '0xb1EDf69cd58737b8B7F5F5e0e85f38d1856efA9E',
  logo: logos_1["default"].RLCLogo
}, {
  address: '0xA406d173c53f28029cf8bc8E422b30CA9a2632e5',
  ethereum: '',
  logo: logos_1["default"].STAKELogo
}, {
  address: '0x64217C40CaA63bDe8B274A7563D2369d224Fa4D1',
  ethereum: '',
  logo: logos_1["default"].RARILogo
}, {
  address: '0x02Bb113AC77546D962Ce0fB4f5352636e5fF3103',
  ethereum: '',
  logo: logos_1["default"].HXROLogo
}, {
  address: '0x9a70c5867eb344E093eB13eeE9283Df37211CC23',
  ethereum: '0xDbee7D16073deB8cAbE0aeAe9bEA10d1db4C50FA',
  logo: logos_1["default"].MAPSLogo
}, {
  address: '0x4ed322A3eCC527C7703785c57Cd05137D3eDDDC1',
  ethereum: '0x5be955852df92009EfEFE4c570E89f04D05E1a84',
  logo: logos_1["default"].FRMLogo
}, {
  address: '0x3268305d5BEcA27595FB10092fD4f960Bf888760',
  ethereum: '',
  logo: logos_1["default"].DFLogo
}, {
  address: '0xfFC634593CE52BC2fa839d21e927C040a7Edc71b',
  ethereum: '',
  logo: logos_1["default"].BZRXLogo
}, {
  address: '0x8ea49cBC336ACcB040bd37ED75c8199725f0C519',
  ethereum: '',
  logo: logos_1["default"].KP3RLogo
}, {
  address: '0x79D45BFb71c0f895b5026C544Ac09F887f5b2bd2',
  ethereum: '',
  logo: logos_1["default"].BAOLogo
}, {
  address: '0x84Ff47ADFD640a0F5475b993045ce81A5C394ABb',
  ethereum: '',
  logo: logos_1["default"].OMILogo
}, {
  address: '0x40C9045528f82ED73836ccB493C56B1e5383017e',
  ethereum: '',
  logo: logos_1["default"].SHIBLogo
}, {
  address: '0x40aacD57B4822bF0FF0F60FACA51f2765314d65f',
  ethereum: '',
  logo: logos_1["default"].ILVLogo
}, {
  address: '0xBDA127C026678933d9023634e6B2f1f42c9681D5',
  ethereum: '',
  logo: logos_1["default"].AXSLogo
}, {
  address: '0x271268cebeB310D8B19F088aDEBF3f247910562c',
  ethereum: '0xeb8f08a975ab53e34d8a0330e0d34de942c95926',
  logo: logos_1["default"].USDCLogo
}, {
  address: '0x0a0Acf6B4B0b3D9ED6526BCcFf0e18bf1402f5b4',
  ethereum: '',
  logo: logos_1["default"].SPELLLogo
}, {
  address: '0x1a64f7EeE7964bF373aeB17591CD33e7ff4763F0',
  ethereum: '',
  logo: logos_1["default"].PREMIALogo
}, {
  address: '0x73af299acF5e178741f480E3F206D3491ea79E97',
  ethereum: '',
  logo: logos_1["default"].ELONLogo
}, {
  address: '0x65f10317C5dbc8adc9f6Bae009987A9BeeD64a3b',
  ethereum: '0xE2517d7Ab220733Be132AD114B7979BBBA3cAFC6',
  logo: logos_1["default"].SLPLogo
}, {
  address: '0x70Db5FEE65888E91C19aBc9b5e11075c2dDa1073',
  ethereum: '',
  logo: logos_1["default"].USDELogo
}];
var mergedTokens = testnetTokens.map(function (token) {
  return __assign(__assign({}, token), tokens_json_1["default"].testnet.find(function (fetchedTokens) {
    return fetchedTokens.address.toLowerCase() === token.address.toLowerCase();
  }));
});
exports["default"] = mergedTokens;